import type { Meta, StoryObj } from '@storybook/react';
import React from 'react';
import Modal from '../Modal';
import Button from '../Button';
import Text from '../Text';
import FullScreenModalLayout from './FullScreenModalLayout';
import { CloseButton, TextButton } from '..';

const meta: Meta<typeof FullScreenModalLayout> = {
  component: FullScreenModalLayout,
};

export default meta;
type Story = StoryObj<typeof FullScreenModalLayout>;

const ModalWithButton = ({
  isOpen: isOpenProp = false,
  children,
}: {
  isOpen?: boolean;
  children: ({
    isOpen,
    close,
  }: {
    isOpen: boolean;
    close: () => void;
  }) => React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = React.useState(isOpenProp);
  const close = React.useCallback(() => setIsOpen(false), []);

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>Open Modal</Button>
      <Modal isOpen={isOpen} onRequestClose={close}>
        {children({ isOpen, close })}
      </Modal>
    </>
  );
};

export const Basic: Story = {
  render: () => {
    return (
      <ModalWithButton>
        {({ close }) => (
          <FullScreenModalLayout>
            <FullScreenModalLayout.Header
              startNode={
                <CloseButton skin="dark" size="large" onClick={close} />
              }
              endNode={
                <TextButton size="small" onClick={close}>
                  Save
                </TextButton>
              }
            >
              <Text size="small" weight="normal" ellipsis>
                Modal Title
              </Text>
            </FullScreenModalLayout.Header>
            <FullScreenModalLayout.Content padding>
              <Text>This is the main content area with padding.</Text>
            </FullScreenModalLayout.Content>
            <FullScreenModalLayout.Footer>
              <Text>Footer</Text>
            </FullScreenModalLayout.Footer>
          </FullScreenModalLayout>
        )}
      </ModalWithButton>
    );
  },
};
